import { render, staticRenderFns } from "./Knowledge.vue?vue&type=template&id=34eaf0c8&scoped=true"
import script from "./Knowledge.vue?vue&type=script&lang=ts"
export * from "./Knowledge.vue?vue&type=script&lang=ts"
import style0 from "./Knowledge.vue?vue&type=style&index=0&id=34eaf0c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34eaf0c8",
  null
  
)

export default component.exports